import logo from './logo.svg';
import '../src/style/main.scss';
import '../src/style/common/common.scss';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import MeasurementSearch from './components/MeasurementSearch';
import Ner from './components/Ner';
import EntityExtractionFromImage from './components/EntityExtractionFromImage';
import EntityExtractionFromDesc from './components/EntityExtractionFromDesc';
import CompleteTheLook from './components/CompleteTheLook';
import Divider from './components/common/Divider';

function Home() {
    return (
        <div>
            <Header />
            <section className="container-wrapper product-highlights">
                <div className="container grid-xxxl">
                <Ner />
                <Divider />
                <MeasurementSearch />
                <Divider />
                <EntityExtractionFromImage />
                <Divider />
                <CompleteTheLook />
                <Divider />
                <EntityExtractionFromDesc />
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Home;
